module.exports = __webpack_public_path__ + "img/05.b67a3686.png";